import axios from '../../localAxios';
import { mergeWorkspaceQuizURL } from '../workspacesURLs';

interface MergeWorkspaceQuizzesParams {
  workspaceId: string;
  name: string;
  workspaceQuizIds: string[];
  parentId: string;
}

export interface MergeWorkspaceQuizzesResponse {
  data: { id: string; workspaceId: string };
  deletedDate: null;
  id: string;
  is_hidden: boolean;
  lock_id: string;
  originallyCreatedBy: string;
  parentFolderId: string;
  publishedBy: string;
  publishedDate: string;
  versionId: string;
  workspaceId: string;
  message: string;
}

export async function mergeWorkspaceQuizzes({
  workspaceId,
  name: name,
  workspaceQuizIds,
  parentId,
}: MergeWorkspaceQuizzesParams) {
  const url = mergeWorkspaceQuizURL(workspaceId);
  const response = await axios.post<MergeWorkspaceQuizzesResponse>(url.href, {
    parent_id: parentId,
    name: name,
    workspace_quiz_ids: workspaceQuizIds,
  });
  return response.data;
}
